import { configureStore } from '@reduxjs/toolkit';
import { useSelector as rawUseSelector, TypedUseSelectorHook } from 'react-redux';
import menuStateReducer from './menuStateSlice';
import loginUserReducer from './loginUserSlice';
import setupUserReducer from './setupUserSlice';

export const store = configureStore({
  reducer: {
    menuState: menuStateReducer,
    loginUser: loginUserReducer,
    setupUser: setupUserReducer,
  },
});

export type AddDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export const useSelector: TypedUseSelectorHook<RootState> = rawUseSelector;
